import React from 'react';

const RadioQuestion = ({ question, answer, onAnswerChange, inputRef }) => {
  const isSelected = (optionId) => String(answer) === String(optionId);

  return (
    <div className="radio-question">
      <h3>{question.question}</h3>
      {question.questionImageUrl && (
        <img className="quiz-question-image" src={question.questionImageUrl} alt="Question" />
      )}
      <div className="options">
        {question.options.map((option, index) => (
          <label
            key={option.id}
            className={`option-label${isSelected(option.id) ? ' selected' : ''}`}
          >
            <input
              type="radio"
              name={`question-${question.id}`}
              value={option.id}
              checked={isSelected(option.id)}
              onChange={(e) => onAnswerChange(question.id, e.target.value)}
            />
            <span className="option-content">
              {option.imageUrl && (
                <img className="quiz-option-image" src={option.imageUrl} alt={`Option ${index + 1}`} />
              )}
              {option.text && <span>{option.text}</span>}
              {!option.text && !option.imageUrl && <span>{`Option ${index + 1}`}</span>}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioQuestion;
